export const INVENTORY_SETTING_NAME = {
  STOCK_RESERVE_WAREHOUSE_ID: "stockReserveWarehouseId",
  STOCK_RESERVE_DURATION: "stockReserveDuration",
  STOCK_RESERVE_CHAT_ID: "stockReserveChatId",
};

export const STOCK_RESERVE_MODULE_SLUG = "inventory/stock-reserve";

export const STOCK_RESERVE_DURATION_DEFAULT = 14;

export const INVENTORY_SETTING_SUBMIT_RULES = {
  stockReserveWarehouseId: {
    required: true,
    type: "number",
    min: 1,
  },
  stockReserveDuration: {
    required: true,
    type: "number",
    min: 1,
  },
};

export const READ_INVENTORY_SETTING = 216013;
export const UPDATE_INVENTORY_SETTING = 216014;
